import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('FormItem', null, { withChildren: true });
